import { render, staticRenderFns } from "./SameCustomerLevelDialog.vue?vue&type=template&id=4253c5d2"
import script from "./SameCustomerLevelDialog.vue?vue&type=script&lang=js"
export * from "./SameCustomerLevelDialog.vue?vue&type=script&lang=js"
import style0 from "./SameCustomerLevelDialog.vue?vue&type=style&index=0&id=4253c5d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports